import { APP_ROUTE_NAMES } from '@/app/types/router'
import { type RouteRecordRaw } from 'vue-router'

const NewCallView = () => import('@/agent/views/NewCallView.vue')

export default [
  {
    path: 'cti/newCall',
    component: NewCallView,
    meta: {
      legacy: true,
      refresh: true,
      exclude: ['/assist/ticket/save'],
      allowBackNavigation: true,
      skipHistory: true,
    },
  },
  {
    path: '/call/provider/genesys/connect.html',
    component: {},
    name: APP_ROUTE_NAMES.GENESYS_AUTH_IFRAME_NAME,
  },
] as Array<RouteRecordRaw>
